import { Place } from "../../types/place-type";
import { Writer } from "../../types/writer-type";
import { Event } from "../../types/event-type";
import { YearEvent } from "../../types/year-event-type";

export type CalendarData = {
  writers: Writer[];
  writersMap: { [key: Writer['id']]: Writer };
  getWriterById: (id: Writer['id']) => Writer;

  places: Place[];
  placesMap: { [key: Place['id']]: Place };
  getPlaceById: (id: Place['id']) => Place;

  events: Event[];
  eventsMap: { [key: Event['id']]: Event };
  getEventById: (id: Event['id']) => Event;

  yearEvents: YearEvent[];
};

export const getCalendarData = ({ writers, places, events, yearEvents }: any): CalendarData => {
  const writersMap = writers.reduce(
    (result: { [key: Writer['id']]: Writer }, writer: Writer) => ({
      ...result,
      [writer.id]: writer,
    }), {}
  );

  const placesMap = places.reduce(
    (result: { [key: Place['id']]: Place }, place: Place) => ({
      ...result,
      [place.id]: place,
    }), {}
  );

  const eventsMap = events.reduce(
    (result: { [key: Event['id']]: Event }, event: Event) => ({
      ...result,
      [event.id]: event,
    }), {}
  );

  return {
    writers,
    writersMap,
    getWriterById: (id: Writer["id"]) => writersMap[id],
    places,
    placesMap,
    getPlaceById: (id: Place["id"]) => placesMap[id],
    events,
    eventsMap,
    getEventById: (id: Event["id"]) => eventsMap[id],
    yearEvents
  };
};
